import { Field } from 'formik';
import { FormikRadioGroup } from '@flexinet/ui-components';

const statusOptions = [
    { value: '', label: 'All Statuses' },
    { value: 'PROSPECT', label: 'Prospect' },
    { value: 'TRIAL', label: 'Trial' },
    { value: 'TRIAL_EXPIRED', label: 'Trial Expired' },
    { value: 'ACTIVE', label: 'Active' },
    { value: 'ACTIVE_GRACE', label: 'Active Grace' },
    { value: 'PAST_DUE', label: 'Past Due' },
    { value: 'SUSPENDED', label: 'Suspended' },
    { value: 'PAUSED', label: 'Paused' },
    { value: 'DOWNGRADED', label: 'Downgraded' },
    { value: 'CANCELLED', label: 'Cancelled' },
    { value: 'INACTIVE', label: 'Inactive' },
    { value: 'BLOCKED', label: 'Blocked' },
    { value: 'ARCHIVED', label: 'Archived' },
];

export const FilterFormComponent = () => {
    return (
        <Field
            name="status"
            label="Status"
            data={statusOptions}
            component={FormikRadioGroup}
            my="md"
        />
    );
};
